import {
  primaryColor,
  dangerColor,
  roseColor,
  grayColor
} from "assets/jss/material-dashboard-pro-react.jsx";


const customInfoLabels = {
  warningLabel: {
    boxShadow: "0 12px 20px -10px rgba(255, 152, 0, 0.18)",
    backgroundColor: "#fef7ec",
    border: "2px dashed #e5ae12",
    borderRadius: "5px",
    color: "#ef8b0f",
    fontWeight: "400",
    fontSize: "16px",
    marginTop: "20px",
    marginBottom: "20px",
    padding: "15px 30px",
    textAlign: "left",
    display: "flex",
    justifyContent: "center"
  }
};

export default customInfoLabels;
